import { create } from 'zustand';

// Tiny shared store so the sidebar (ConsoleLayout), the Usage page, and the
// WalletModal itself can all open the single modal that is mounted once at the
// layout root.
interface WalletModalState {
  open: boolean;
  show: () => void;
  hide: () => void;
}

export const useWalletModal = create<WalletModalState>((set) => ({
  open: false,
  show: () => set({ open: true }),
  hide: () => set({ open: false }),
}));
